module.exports = __webpack_public_path__ + "img/4.3c9fe55e.jpg";